// Debug utility
const DEBUG = {
  enabled: process.env.NODE_ENV === 'development',
  log: (prefix: string, data?: any) => {
    if (DEBUG.enabled) {
      console.log(`[${prefix}]`, data);
    }
  },
};

export { DEBUG };
